import { useTranslation } from 'react-i18next';
import { useRootSelector } from '../../../../store/hooks';
import { selectSiteHeader } from '../../../../store/features/siteHeader';
import { selectSitePricingProductsStatusCode } from '../../store/features/products';
import { selectSitePricingPackagesStatusCode } from '../../store/features/packages';

import { MetaTags } from '../../../hub/shared/MetaTags';
import PaymentProvider from '../../shared/PaymentProvider';
import Layout from '../../shared/layouts/Layout';
import PageLayout from '../../shared/layouts/PageLayout';
import PackageSelectionForm from './components/PackageSelectionForm';
import ErrorHandler from '../../shared/layouts/ErrorHandler';
import SelectPackageGtm from './components/SelectPackageGtm';

export default function SelectPackage() {
  const { t } = useTranslation();
  const siteHeader = useRootSelector(selectSiteHeader);
  const productsStatusCode = useRootSelector(
    selectSitePricingProductsStatusCode,
  );
  const packagesStatusCode = useRootSelector(
    selectSitePricingPackagesStatusCode,
  );

  const {
    data: {
      bookingMetaTitle,
      bookingMetaDescription,
      bookingHideFromSearchEngines,
    },
    meta: { title, description } = {},
  } = siteHeader;

  const pageMetaTitle = bookingMetaTitle || `${t('event.book-now')} | ${title}`;

  const robots = bookingHideFromSearchEngines
    ? 'noindex, nofollow'
    : 'index, follow';

  return (
    <ErrorHandler statusCodes={[productsStatusCode, packagesStatusCode]}>
      <SelectPackageGtm>
        <PaymentProvider>
          <Layout
            disableUpperFooter
            className="informa-payment-select-package-page"
          >
            <MetaTags
              title={pageMetaTitle}
              description={bookingMetaDescription || description}
              robots={robots}
            />
            <PageLayout variant="full">
              <PackageSelectionForm />
            </PageLayout>
          </Layout>
        </PaymentProvider>
      </SelectPackageGtm>
    </ErrorHandler>
  );
}
